import script from "./FriendsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./FriendsView.vue?vue&type=script&setup=true&lang=ts"

import "./FriendsView.vue?vue&type=style&index=0&id=90e22c60&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-90e22c60"]])

export default __exports__